import { useEffect, useState } from "react";
import { Form, Input, Modal, Spin, message } from "antd";
import { useUserContext } from "../context/dashboard-context";
import ServiceCard from "../components/zapchast-card/index";
import CustomPagination from "../components/pagination";
import ServiceImageUploader from "../components/imageUploader/ServiceImageUploader";
import api from "../context/api";
import "./services-page.scss";

const { TextArea } = Input;

const ServicesPage = () => {
  const { token } = useUserContext();
  const [loading, setLoading] = useState(false);
  const [services, setServices] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalServices, setTotalServices] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();

  const [formData, setFormData] = useState({
    title_uz: "",
    title_ru: "",
    title_en: "",
    text_uz: "",
    text_ru: "",
    text_en: "",
    imageFile: null,
  });

  const fetchServices = async (page = 1) => {
    setLoading(true);
    try {
      const response = await api.get(`/service/?page=${page}`);
      setServices(
        Array.isArray(response.data) ? response.data : response.data.data || []
      );
      setTotalServices(response.data.totalCount || 0);
    } catch (error) {
      console.error("Xizmatlarni yuklashda xatolik:", error);
      message.error("Xizmatlarni yuklashda xatolik yuz berdi");
    } finally {
      setLoading(false);
    }
  };

  const addService = async () => {
    if (!formData.imageFile) {
      message.error("Iltimos, rasm yuklang");
      return;
    }

    setLoading(true);
    const formDataToSend = new FormData();

    Object.entries(formData).forEach(([key, value]) => {
      if (key !== "imageFile" && value) {
        formDataToSend.append(key, value);
      }
    });

    if (formData.imageFile) {
      formDataToSend.append("image_url", formData.imageFile);
    }

    try {
      const response = await api.post("/service/", formDataToSend, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if ([200, 201].includes(response.status)) {
        message.success("Xizmat muvaffaqiyatli qo‘shildi");
        fetchServices(currentPage);
        form.resetFields();
        setFormData({
          title_uz: "",
          title_ru: "",
          title_en: "",
          text_uz: "",
          text_ru: "",
          text_en: "",
          imageFile: null,
        });
        setIsModalOpen(false);
      }
    } catch (error) {
      console.error("Xizmatni qo‘shishda xatolik:", error);
      message.error(error.response?.data?.message || "Xizmatni qo‘shib bo‘lmadi");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchServices();
  }, []);

  const handleFormChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  return (
    <div className="services-page">
      <div className="page-header">
        <h1>Servislar</h1>
        <button onClick={() => setIsModalOpen(true)}>
          + Yangi xizmat qo‘shish
        </button>
      </div>

      {loading && services.length === 0 ? (
        <Spin size="large" />
      ) : services.length > 0 ? (
        <>
          <div className="services-grid">
            {services.map((service) => (
              <ServiceCard
                key={service.id}
                service={service}
                onUpdate={fetchServices}
              />
            ))}
          </div>

          <CustomPagination
            current={currentPage}
            total={totalServices}
            onChange={(page) => {
              setCurrentPage(page);
              fetchServices(page);
            }}
          />
        </>
      ) : (
        <div className="no-services">
          <p>Hech qanday xizmat topilmadi. Birinchi xizmatni qo‘shing.</p>
        </div>
      )}

      <Modal
        title="Yangi xizmat qo‘shish"
        open={isModalOpen}
        onCancel={() => {
          setIsModalOpen(false);
          form.resetFields();
        }}
        footer={null}
        width={800}
      >
        <Spin spinning={loading}>
          <Form form={form} onFinish={addService}>
            <div className="form-section">
              <Form.Item label="Sarlavha (O‘zbek)" required>
                <Input
                  value={formData.title_uz}
                  onChange={(e) => handleFormChange("title_uz", e.target.value)}
                />
              </Form.Item>

              <Form.Item label="Sarlavha (Rus)" required>
                <Input
                  value={formData.title_ru}
                  onChange={(e) => handleFormChange("title_ru", e.target.value)}
                />
              </Form.Item>

              <Form.Item label="Sarlavha (Ingliz)">
                <Input
                  value={formData.title_en}
                  onChange={(e) => handleFormChange("title_en", e.target.value)}
                />
              </Form.Item>

              <Form.Item label="Tavsif matni (O‘zbek)">
                <TextArea
                  rows={4}
                  value={formData.text_uz}
                  onChange={(e) => handleFormChange("text_uz", e.target.value)}
                />
              </Form.Item>

              <Form.Item label="Tavsif matni (Rus)">
                <TextArea
                  rows={4}
                  value={formData.text_ru}
                  onChange={(e) => handleFormChange("text_ru", e.target.value)}
                />
              </Form.Item>

              <Form.Item label="Tavsif matni (Ingliz)">
                <TextArea
                  rows={4}
                  value={formData.text_en}
                  onChange={(e) => handleFormChange("text_en", e.target.value)}
                />
              </Form.Item>

              <Form.Item label="Rasm" required>
                <ServiceImageUploader
                  imageFile={formData.imageFile}
                  setImageFile={(file) => handleFormChange("imageFile", file)}
                />
              </Form.Item>
            </div>

            <div className="form-actions">
              <button
                type="button"
                className="cancel-btn"
                onClick={() => setIsModalOpen(false)}
              >
                Bekor qilish
              </button>
              <button
                type="submit"
                className="submit-btn"
                disabled={
                  !formData.title_uz ||
                  !formData.title_ru ||
                  !formData.imageFile
                }
              >
                Xizmatni qo‘shish
              </button>
            </div>
          </Form>
        </Spin>
      </Modal>
    </div>
  );
};

export default ServicesPage;
